import DatabaseModel from './DatabaseModel.js';

var AgentChat = Object.create(DatabaseModel);

AgentChat.model = 'ai/agent';

AgentChat.getContext = function() {
    var self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/context',
        method: 'GET',
        data: {}
    }, false);
};

// Modelo con el que responderá el agente (alias `conversaciones` del catálogo de simecal-ai).
AgentChat.getModelo = function() {
    var self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/modelo',
        method: 'GET',
        data: {}
    }, false);
};

// Plazo de conservación de las conversaciones (#933), para el aviso del chat.
AgentChat.getPolitica = function() {
    return this.sendRequest({
        url: this.server_movilidad + this.prefix + this.model + '/politica',
        method: 'GET',
        data: {}
    }, false);
};

AgentChat.ask = function(params) {
    var self = this;
    params = params || {};
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/ask',
        method: 'POST',
        data: params.data || {}
    }, false);
};

AgentChat.getDocumentSourcePreview = function(params) {
    var self = this;
    params = params || {};
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/document-source-preview',
        method: 'POST',
        data: params.data || {}
    }, false);
};

AgentChat.getConversation = function(params) {
    var self = this;
    params = params || {};
    if (!params.itemId) return Promise.reject({ message: 'conversationId not defined' });
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/conversation/' + params.itemId,
        method: 'GET',
        data: {}
    }, false);
};

AgentChat.listConversations = function(params) {
    var self = this;
    params = params || {};

    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/conversations',
        method: 'GET',
        data: {
            archived: params.archived,
            limit: params.limit || 30
        }
    }, false).then(function(response) {
        if (Array.isArray(response)) {
            return response;
        }

        if (response && Array.isArray(response.list)) {
            return response.list;
        }

        return [];
    });
};

AgentChat.deleteConversation = function(params) {
    var self = this;
    params = params || {};
    if (!params.itemId) return Promise.reject({ message: 'conversationId not defined' });
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/conversation/' + params.itemId + '/delete',
        method: 'POST',
        data: {}
    }, false);
};

AgentChat.updateConversation = function(params) {
    var self = this;
    params = params || {};
    if (!params.itemId) return Promise.reject({ message: 'conversationId not defined' });
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/conversation/' + params.itemId + '/update',
        method: 'POST',
        data: params.data || {}
    }, false);
};

AgentChat.executePendingAction = function(params) {
    var self = this;
    params = params || {};
    if (!params.itemId) return Promise.reject({ message: 'pendingActionId not defined' });
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/pending-action/' + params.itemId + '/execute',
        method: 'POST',
        data: {}
    }, false);
};

AgentChat.discardPendingAction = function(params) {
    var self = this;
    params = params || {};
    if (!params.itemId) return Promise.reject({ message: 'pendingActionId not defined' });
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/pending-action/' + params.itemId + '/discard',
        method: 'POST',
        data: {}
    }, false);
};

export default AgentChat;
